/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – nanmnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

const dataInit = {
    customer_cd: '',
    customer_name: '',
    location_cd: '',
    location_name: '',
    zipcode: '',
    address1: '',
    address2: '',
    address3: '',
    phone: '',
    fax: '',
    contact_first_name: '',
    contact_last_name: '',
    contact_first_name_kana: '',
    contact_last_name_kana: '',
    contact_email: '',
    contact_tel: '',
    order_expectation: '',
    order_remarks: ''
};

export default {
    namespaced: true,
    state: {
        isSuccess: false,
        data: { ...dataInit },
        selectOptionKey: ['id', 'content'],
        totalRows: 0,
        listData: [],
        data_select: {
            date_of_payment: [
                {
                    id: 1,
                    content: '今月'
                },
                {
                    id: 2,
                    content: '翌月'
                },
                {
                    id: 3,
                    content: '翌々月'
                }
            ],
            closing_date: [
                {
                    id: 1,
                    content: '5日'
                },
                {
                    id: 2,
                    content: '10日'
                },
                {
                    id: 3,
                    content: '15日'
                },
                {
                    id: 4,
                    content: '20日'
                },
                {
                    id: 5,
                    content: '25日'
                },
                {
                    id: 6,
                    content: '末日'
                }
            ],
            usage: [
                {
                    code: 1,
                    name: '無'
                },
                {
                    code: 2,
                    name: '有'
                }
            ]
        },
        msgNoData: '該当するデータが存在しません。'
    },
    mutations: {
        resetDataInit(state, data) {
            if (data?.mode) {
                state.data = { ...dataInit };
                state.data.location_cd = data.location_cd;
            } else {
                state.data = {
                    ...dataInit,
                    customer_cd: data.customer_cd,
                    customer_name: data.customer_name
                };
            }
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setData(state, data) {
            state.data = {
                ...data,
                // phone: data.tel1 ?? '' + '-' + data.tel2 ?? '' + '-' + data.tel3 ?? '',
                phone: `${data.tel1 ?? ''}-${data.tel2 ?? ''}-${data.tel3 ?? ''}`,
                // fax: data.fax1?? '' + '-' + data.fax2 ?? '' + '-' + data.fax3 ?? '',
                fax: `${data.fax1 ?? ''}-${data.fax2 ?? ''}-${data.fax3 ?? ''}`,
                // contact_tel:
                //     data.contact_tel1 +
                //     '-' +
                //     data.contact_tel2 +
                //     '-' +
                //     data.contact_tel3
                contact_tel: `${data.contact_tel1 ?? ''}-${data.contact_tel2 ?? ''}-${data.contact_tel3 ?? ''}`
            };
        },
        setTotalRows(state, data) {
            state.totalRows = data;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        }
    },
    actions: {
        /**
         * get user info
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        getCustomerInfo(context, param) {
            try {
                repository.getCustomerInfo(param).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        context.commit('setData', data.Data);
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        /**
         * get user info
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        getCustomerMFIL001(context, input) {
            repository.getCustomerMFIL001(input.body).then((res) => {
                const { data } = res;
                if (data.Code == 200) {
                    if (input.callback) {
                        input.callback(data.Data);
                    }
                } else {
                    if (input.onError) {
                        input.onError(data.Data.message);
                    }
                }
            });
        },

        /**
         * get area info
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        getAreaInfo(context, input) {
            try {
                repository.getAreaInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },

        /**
         * get office info
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        getOfficeInfo(context, input) {
            try {
                repository.getOfficeInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        /**
         * get user info
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        store(context, input) {
            try {
                repository.store(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        }
    }
};
